import { useEffect, useState } from "react";
import { useContract } from "./useContract";
import { useTemplate } from "~/entity/Template";

export const useGetContractById = (id: string, printFormId: string) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getContractById } = useContract();
  const { getTemplateById } = useTemplate();

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const [responseContract, templateId] = await Promise.all([
        getContractById(id),
        getTemplateById(printFormId),
      ]);
      if (responseContract.status && responseContract.status >= 400) {
        throw new Error(`${responseContract.status}`);
      }
      if (templateId.status && templateId.status >= 400) {
        throw new Error(`${templateId.status}`);
      }
      let temp = {
        value: templateId.data.id.toString(),
        label: templateId.data.name,
      };
      const dataFormat = responseContract.data;
      setData({ printForm: temp, ...dataFormat });
    } catch (error) {
      setError("Не удалось загрузить договор");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { data, isLoading, error };
};
